/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useCallback, useMemo, useRef } from "react";
/* eslint-enable @typescript-eslint/no-unused-vars */
// antd:
import { Button } from "antd";

// Components:
import AppIcons from "./AppIcons.tsx";
import SpanE from "./SpanE.tsx";

// Redux-hooks:
import { useAppSelector } from "../../libs/redux-hooks.ts";
// Reducers:
import { getDesktopType, getDict } from "../../libs/reducer.ts";

const { rz } = window;

type componentProps = {
  modalKey:string,
  closePortal:(e:React.MouseEvent) => void,
  // eslint-disable-next-line react/boolean-prop-naming
  closeOnEsc?:boolean,
  title?:string,
  icon?:React.ReactNode,
  isDisableCloseButton?:boolean,
  isHiddenCloseButton?:boolean,
  zIndex?:number,
  className?:string,
  style?:React.CSSProperties,
  children?:React.ReactNode
};

const ModalFullscreen:FC<componentProps> = ({modalKey, closePortal, closeOnEsc, title, icon, isDisableCloseButton, isHiddenCloseButton, zIndex, className, style, children}) => {
  const dct = useAppSelector(getDict);
  const isMobile = useAppSelector(getDesktopType);

  const clsu = useMemo<Array<string>>(() => {
    const userClss = (className || "").split(" ");
    if (!rz.arrContains(userClss, (/-overflow-/igm))) { userClss.push("uk-overflow-hidden") }
    if (!rz.arrContains(userClss, (/^rz-theme-/igm))) { userClss.push("rz-theme-d5") }
    // if (!rz.arrContains(userClss, (/^rz-margin-top-/igm))) { userClss.push("rz-margin-top-40") } // Нельзя, т.к. высота окна = "100vh", нужно будет вычитать margin-top из нее
    return userClss;
  }, [className]);

  const toolbarRef = useRef(null);
  // {...style, height: (window.innerHeight) - (toolbarRef?.current?.offsetHeight || 40), width: "100%", marginTop: (toolbarRef?.current?.offsetHeight || 40)}

  const keyUp = useCallback((e) => {
    if (e.key === "Escape") { e.preventDefault(); closePortal(e) }
  }, [closePortal]);

  useEffect(() => {
    if (closeOnEsc) {
      document.addEventListener("keyup", keyUp);
      return () => { document.removeEventListener("keyup", keyUp) }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div key={modalKey + "-modal-wrapper"} style={{
      position: "absolute", left: 0, top: 0, overflow: "hidden",
      width: "100vw", height: "100vh", zIndex: zIndex || 900
    }}>
      <style>
        {":root{--" + modalKey + "-height: 100vh; --" + modalKey + "-width: 100vw;}"}
      </style>
      <div key={modalKey + "-modal-header"} id={modalKey + "-modal-header"} ref={toolbarRef} className="uk-position-top uk-margin-remove" style={{zIndex: (zIndex || 900) + 5}}>
        <nav className="uk-navbar uk-navbar-container uk-margin-remove uk-flex uk-flex-row uk-flex-nowrap rz-padding-5 rz-theme-d4 rz-border-bottom-d2">
          <div className="uk-navbar-left">
            <div className="uk-navbar-item uk-padding-remove">
              <span className="uk-text-lead rz-txt-light uk-flex uk-flex-middle">{icon}</span>
              <SpanE className="uk-text-lead rz-txt-light rz-margin-left-10 uk-overflow-hidden" uk-tooltip={title}>{title}</SpanE>
            </div>
          </div>
          <div className="uk-navbar-right" style={(isHiddenCloseButton ? {display: "none"} : undefined)}>
            <div className="uk-navbar-item uk-padding-remove rz-margin-right-5">
              <Button size={isMobile ? undefined : "large"} type="primary" icon={<AppIcons icopath="ai/AiOutlineClose" attrs={{}} />} onClick={closePortal} uk-tooltip={dct.p.buttonclose}
                disabled={isDisableCloseButton} />
            </div>
          </div>
        </nav>
      </div>
      <div key={modalKey + "-modal-content"} id={modalKey} className={clsu.join(" ")} style={{...style, overflow: "auto", marginTop: ((toolbarRef?.current?.offsetHeight || 40)) + 5}}>
        {children}
      </div>
    </div>
  );
}

export default ModalFullscreen;
